<mat-form-field appearance="outline" class="si-entity-field">
    <mat-label>{{ labelKey | translate }}</mat-label>

    <input matInput
           [formControl]="control"
           [matAutocomplete]="auto"
           (input)="onInput($any($event.target).value)">

    <mat-icon matSuffix class="si-unknown-icon" *ngIf="isUnknown"
              [matTooltip]="'MENU.SPECIAL_INSTRUCTIONS.UNKNOWN_ID_HINT' | translate">warning
    </mat-icon>

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="display">
        <mat-option *ngFor="let option of visibleOptions; trackBy: trackById" [value]="option.id">
            <span class="si-option-label">{{ option.label }}</span>
            <span class="si-option-hint">{{ option.hint }}</span>
        </mat-option>

        <mat-option *ngIf="hiddenOptionsCount > 0" disabled>
            <span class="si-option-hint">
                {{ 'MENU.SPECIAL_INSTRUCTIONS.MORE_OPTIONS' | translate: {count: hiddenOptionsCount} }}
            </span>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
